module.exports = __webpack_public_path__ + "static/images/containers/ShopView/images/small/package_m.79b73d2d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/images/small/package_m.png
// module id = 991
// module chunks = 16